import React from 'react'
import { TeamOutlined } from '@ant-design/icons'
import styled from 'styled-components'
import { Text } from 'styles/reactnative'
import Contracts2 from '../../../components/PositionColumns/Contracts2'
import EntryTime from '../../../components/PositionColumns/EntryTime'
import KrwPrice from '../../../components/PositionColumns/KrwPrice'
import PnlPrice from '../../../components/PositionColumns/PnlPrice'
import Price from '../../../components/PositionColumns/Price'
import Quantity from '../../../components/PositionColumns/Quantity'
import UserTag from '../../../components/UserTag'
import { COLORS } from '../../../constants'

const GroupTag = styled.span`
	display: inline-flex;
	align-items: center;
	padding: 2px 6px;
	background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%);
	color: white;
	border-radius: 4px;
	font-size: 10px;
	font-weight: 500;
	white-space: nowrap;
	height: 20px;
`

export const PositionClosedTableColumn: any = (
	mutate = () => {},
	showUserModal
) => {
	return [
		{
			title: '번호',
			dataIndex: 'id',
			width: 80,
			align: 'center',
			render: (text, data) => <Text>{text}</Text>,
		},
		{
			title: '사용자',
			dataIndex: 'user_id',
			align: 'center',
			width: 120,

			sorter: (a, b) => {
				//abcd 가나다순
				if (a.fullname > b.fullname) {
					return 1
				} else if (a.fullname < b.fullname) {
					return -1
				} else {
					return 0
				}
			},
			render: (text, data) => (
				<UserTag
					userid={data?.user_id}
					email={data?.email}
					phone={data?.phone}
					nickname={data?.fullname || data?.nickname}
					level={data?.level}
					onClick={() => {
						showUserModal(data?.user_id)
					}}
				/>
			),
		},
		{
			title: '그룹',
			align: 'center',
			dataIndex: 'referral_code',
			width: 100,
			render: (text, data) => (
				text ? (
					<GroupTag>
						<TeamOutlined style={{ fontSize: 10, marginRight: 2 }} />
						{text}
					</GroupTag>
				) : (
					<span style={{ color: '#999', fontSize: 11 }}>-</span>
				)
			),
		},
		{
			title: '종목',
			dataIndex: 'pairs',
			key: 'pairs',
			align: 'center',
			render: (text, record) => <Contracts2 data={record} />,
		},
		{
			title: '수량',
			align: 'center',
			dataIndex: 'qty',
			render: (text, data) => <Quantity data={data} />,
		},
		{
			title: '평단가',
			align: 'center',
			dataIndex: 'entryPrice',
			render: (text, data) => (
				<Price
					price={data?.pos_price}
					ep_id={data?.exchange_pairs_id}
				/>
			),
		},
		{
			title: '종료 가격',
			align: 'center',
			dataIndex: 'tradePrice',
			render: (text, data) => (
				<Price
					price={
						data?.limit_market == 'M'
							? data?.trade_price
							: data?.order_price
					}
					ep_id={data?.exchange_pairs_id}
				/>
			),
		},
		{
			title: '증거금',
			align: 'center',
			dataIndex: 'margin',
			render: (text, data) => (
				<KrwPrice
					price={data?.margin}
					style={{ color: COLORS.black }}
				/>
			),
		},
		{
			title: '매매손익',
			align: 'center',
			dataIndex: 'realizedpl',
			render: (text, data) => <KrwPrice price={data?.pnl_price} dp={0} />,
		},
		{
			title: '수수료',
			align: 'center',
			dataIndex: 'fee',
			render: (text, data) => (
				<PnlPrice
					price={-Math.abs(data?.fee_price)}
					dp={0}
					krw={true}
				/>
			),
		},
		{
			title: '진입일',
			dataIndex: 'entryTime',
			align: 'center',
			render: (text, data) => (
				<EntryTime time={data?.created_at} offset={0} />
			),
		},
	]
}
